// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1a4fe20a","256":"2ef7dab0","292":"1f074256","312":"2e29c778","502":"5f4309e2","617":"c2cb4bc1","672":"477a6254","808":"73d8b9de","842":"01821987"}[chunkId] + ".chunk.js";
};